import tie from "../assets/tie.png";
import sneakin from "../assets/sneakin.png";
import kronos from "../assets/kronos.png";
import linkzy from "../assets/linkzy.jpg";
import rn from "../assets/reactnative.png";
import osteovet from "../assets/osteovet.png";
import teresa from "../assets/teresa.png";
import nicole from "../assets/nicole.png";
import antoinege from "../assets/antoinege.png";

const CardContent = {
  web: [
    {
      id: 101,
      title: "Osteo Vet Jenna",
      img: osteovet,
      description:
        "Website for a veterinary osteopath. Built with Webflow, focusing on clean UX and mobile-first design.",
      techno: "[Webflow]",
      link: "https://osteo-vet-jenna.webflow.io",
    },
    {
      id: 102,
      title: "Teresa Holistic Flow",
      img: teresa,
      description:
        "Website for a holistic wellness practitioner. Custom design with booking integration and SEO optimization.",
      techno: "[Webflow]",
      link: "https://teresaholisticflow.com/",
    },
    {
      id: 103,
      title: "Nicole Tripier",
      img: nicole,
      description:
        "Webmaster & site management. Content updates, SEO maintenance and performance monitoring.",
      techno: "[Webflow — Management]",
      link: "https://nicoletripier.fr",
    },
    {
      id: 104,
      title: "antoinege.com",
      img: antoinege,
      description:
        "Personal portfolio website. Built with React, SCSS and a parallax hero section.",
      techno: "[React, SCSS]",
      link: "https://www.antoinege.com/",
    },
    {
      id: 1,
      title: "Tech it easy",
      img: tie,
      description:
        "Project for a start-up that needed a web media platform. The website proposes content about the digital world.",
      techno: "[HTML, CSS, Vanilla JS]",
      link: "https://github.com/antg01/tech-it-easy",
    },
    {
      id: 2,
      title: "Sneak In",
      img: sneakin,
      description:
        "Web app for sneaker aficionados displaying live data from an external API with search and filter features.",
      techno: "[React]",
      link: "https://github.com/antg01/sneakIn",
    },
  ],
  software: [
    {
      id: 3,
      title: "Kronos BnB",
      img: kronos,
      description:
        "24h hackathon project — subject: 'Back from the Future'. Full-stack Airbnb-style app. 1st place.",
      techno: "[React, Node/Express, MySQL]",
      link: "https://github.com/antg01/kronos",
    },
    {
      id: 13,
      title: "Born2beroot",
      img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/debian/debian-original.svg",
      description:
        "System administration project: set up a secure Debian VM with strict partitioning, SSH, firewall and sudo policies.",
      techno: "[Linux, Bash, VM]",
      link: "https://github.com/antg01/born2beroot",
    },
    {
      id: 14,
      title: "push_swap",
      img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/c/c-original.svg",
      description:
        "Sort a stack of integers using two stacks and a limited set of operations with the minimum number of moves.",
      techno: "[C]",
      link: "https://github.com/antg01/push_swap",
    },
    {
      id: 20,
      title: "minitalk",
      img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/c/c-original.svg",
      description:
        "Inter-process communication program using UNIX signals (SIGUSR1/SIGUSR2) to transmit strings between a server and a client.",
      techno: "[C, Unix, Signals]",
      link: "https://github.com/antg01/minitalk",
    },
    {
      id: 16,
      title: "so_long",
      img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/opengl/opengl-original.svg",
      description:
        "2D game using the MLX42 library. Player must collect items and reach the exit while avoiding obstacles.",
      techno: "[C, MLX42]",
      link: "https://github.com/antg01/so_long",
    },
    {
      id: 17,
      title: "philosophers",
      img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/c/c-original.svg",
      description:
        "Implementation of the dining philosophers problem using threads and mutexes to avoid data races and deadlocks.",
      techno: "[C, Threads, Mutexes]",
      link: "https://github.com/antg01/philosophers",
    },
    {
      id: 18,
      title: "minishell",
      img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bash/bash-original.svg",
      description:
        "A minimal Bash-like shell with parsing, pipes, redirections, environment variables and built-in commands.",
      techno: "[C, Unix]",
      link: "https://github.com/antg01/minishell",
    },
    {
      id: 21,
      title: "CPP Modules",
      img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/cplusplus/cplusplus-original.svg",
      description:
        "Series of modules (00–09) covering OOP in C++: classes, inheritance, polymorphism, templates, STL and exceptions.",
      techno: "[C++]",
      link: "https://github.com/antg01/cpp_modules",
    },
    {
      id: 19,
      title: "cub3D",
      img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/opengl/opengl-original.svg",
      description:
        "A 3D raycasting engine inspired by Wolfenstein 3D, built from scratch using the MLX42 graphics library.",
      techno: "[C, MLX42, Raycasting]",
      link: "https://github.com/antg01/cub3D",
    },
    {
      id: 23,
      title: "ft_transcendence",
      img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/typescript/typescript-original.svg",
      description:
        "Full-stack web app featuring a real-time multiplayer Pong game, user authentication (OAuth2), live chat and friend system.",
      techno: "[TypeScript, NestJS, React, PostgreSQL]",
      link: "https://github.com/antg01/ft_transcendence",
    },
    {
      id: 22,
      title: "webserv",
      img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/cplusplus/cplusplus-original.svg",
      description:
        "HTTP/1.1 compliant web server built from scratch in C++. Handles routing, CGI, multiple virtual hosts and non-blocking I/O.",
      techno: "[C++, HTTP, Networking]",
      link: "https://github.com/antg01/webserv",
    },
  ],
  mobile: [
    {
      id: 4,
      title: "Us",
      img: rn,
      description:
        "Mobile app for an expat community. Users can create and manage events, meet locals and share experiences.",
      techno: "[React Native, Redux, Node/Express, MySQL]",
      link: "https://github.com/antg01/UsProject",
    },
    {
      id: 5,
      title: "Linkzy",
      img: linkzy,
      description:
        "48h hackathon by Spielberg Consulting & SD Worx. Professional networking concept for in-person events.",
      techno: "[React Native, Redux, Node/Express, MySQL]",
      link: "https://github.com/antg01/Linkzy",
    },
  ],
};

export default CardContent;
